import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VehicleFingerprintContext, VehicleFingerprintSummary } from '../../vehicle-fingerprint.models';

@Component({
  selector: 'app-vehicle-fingerprint-kpi-panel',
  templateUrl: './kpi-panel.component.html',
  styleUrls: ['./kpi-panel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintKpiPanelComponent {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly kpis = [
    { field: 'iRecordCount', label: 'رکوردهای مبنا', description: 'تعداد رکوردهای تحلیل‌شده', color: 'cyan', icon: 'fa-database', digits: '1.0-0' },
    { field: 'fElectricalPowerMean', label: 'میانگین ولتاژ', description: 'مرجع الکتریکی / ولت', color: 'gold', icon: 'fa-bolt', digits: '1.2-2' },
    { field: 'fSpeedMean', label: 'میانگین سرعت', description: 'کیلومتر بر ساعت', color: 'green', icon: 'fa-tachometer', digits: '1.1-1' },
    { field: 'fDailyDistanceMean', label: 'مسافت روزانه', description: 'کیلومتر / روز', color: 'blue', icon: 'fa-road', digits: '1.1-1' },
    { field: 'fDailyTripCountMean', label: 'تعداد سفر', description: 'میانگین روزانه', color: 'purple', icon: 'fa-exchange', digits: '1.1-1' },
    { field: 'fDailyMovingHours', label: 'مدت حرکت', description: 'ساعت / روز', color: 'cyan', icon: 'fa-clock-o', digits: '1.2-2' },
  ] as const;

  getValue(field: keyof VehicleFingerprintSummary): number | null {
    const value = this.context.summary?.[field];
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
  }
}
